import { RiotbarLocaleToPosixMap } from "./localization";
export var RSOPrompt;
(function (RSOPrompt) {
    RSOPrompt["LOGIN"] = "login";
    RSOPrompt["SIGNUP"] = "signup";
})(RSOPrompt || (RSOPrompt = {}));
const CMSlocaleToRSOLocale = (locale) => {
    return RiotbarLocaleToPosixMap[locale || "en_US"];
};
const isValidUrl = (urlString) => {
    try {
        return urlString && Boolean(new URL(urlString));
    }
    catch (e) {
        return false;
    }
};
export const setRedirectUri = (prompt, redirectUrl) => {
    if (isValidUrl(redirectUrl)) {
        return redirectUrl;
    }
    const newRedirectUrl = `${window.location.origin}/${redirectUrl}`;
    if (isValidUrl(newRedirectUrl)) {
        return newRedirectUrl;
    }
    return window.location.href;
};
export async function createAuthorizationUrl(prompt, locale, redirect_uri) {
    let authorizationUrl = window.RiotBar.account.getLoginUrl();
    if (redirect_uri) {
        authorizationUrl += `?uri=${encodeURIComponent(redirect_uri)}`;
    }
    if (prompt === RSOPrompt.SIGNUP) {
        authorizationUrl += "&prompt=signup&show_region=true";
    }
    if (locale) {
        authorizationUrl += `&locale=${CMSlocaleToRSOLocale(locale)}`;
    }
    return {
        nonce: "",
        authorizationUrl,
    };
}
//# sourceMappingURL=utils.js.map